
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Send } from 'lucide-react';

interface ChatInputAreaProps {
  onSendMessage: (message: string) => void;
  isLoading: boolean;
}

const ChatInputArea = ({ onSendMessage, isLoading }: ChatInputAreaProps) => {
  const [inputMessage, setInputMessage] = useState('');
  
  const handleSend = () => {
    if (inputMessage.trim()) {
      onSendMessage(inputMessage);
      setInputMessage('');
    }
  };
  
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  
  return (
    <div className="p-4 border-t">
      <div className="flex gap-2">
        <Textarea
          placeholder="Type your message..."
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          className="resize-none min-h-[60px] rounded-xl"
        />
        <Button 
          onClick={handleSend} 
          disabled={!inputMessage.trim() || isLoading}
          className="rounded-xl shrink-0"
        >
          <Send size={18} />
        </Button>
      </div>
    </div>
  );
};

export default ChatInputArea;
